















































module.exports =
  name: 'planning_modal_example'
  props: ['reserves_changes', 'visible', 'surplus', 'number']
  data: ->
    solution: false
  methods:
    showSolution: ->
      @solution = true
      @$emit('show_solution')
